if(document.querySelector("#properties_hardware_color")) {
  document.querySelector("#properties_hardware_color").addEventListener("change", function() {
    console.log(this.value);
    document.querySelector(".properties_hardware_color_value").value = this.value;
  });
}


if(document.querySelector("#properties_leather_color")) {
  document.querySelector("#properties_leather_color").addEventListener("change", function() {
    console.log(this.value);
    document.querySelector(".properties_leather_color_value").value = this.value;
  });
}

if(document.querySelector("#properties_fastening_color")) {
  document.querySelector("#properties_fastening_color").addEventListener("change", function() {
    console.log(this.value);
    document.querySelector(".properties_fastening_color_value").value = this.value;
  });
}

if(document.querySelector("#properties_fitting_color")) {
  document.querySelector("#properties_fitting_color").addEventListener("change", function() {
    console.log(this.value);
    document.querySelector(".properties_fastening_color_value").value = this.value;
  });
}



if(document.querySelector(".custom-variant-options-group .custom-variant-option-select")) {
  var custom_variant_select = document.querySelectorAll(".custom-variant-options-group .custom-variant-option-select");

  custom_variant_select.forEach(variant_select => {
    variant_select.addEventListener("change", function() {
      const select_handle = this.getAttribute("select-handle");
      const select_value = this.value;
      console.log("value : ", this.value);
      console.log("select_handle : ", select_handle);
      this.closest(".product__block").querySelector(".properties_color__title").innerHTML = select_value;
      if(document.querySelector("#" + select_handle)) {
        document.querySelector("#" + select_handle).value = select_value;
      }
    });
  });

}